// components/modals/ConfirmationModal.tsx

import React from 'react';
import { Modal, Box } from '@mui/material';
import Button from '../button'; // Use your existing button component
import './confirmation-modal.scss'; // Style as needed

interface ConfirmationModalProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  loading = false,
  confirmText = 'Yes',
  cancelText = 'No',
}) => {
  return (
    <Modal open={open} onClose={onCancel} className="confirmation-modal-root">
      <Box className="confirmation-modal-box">
        <button className="modal-close-btn" onClick={onCancel} aria-label="Close">×</button>
        {title && <h3 className="confirmation-title">{title}</h3>}        
        <div className="confirmation-message" dangerouslySetInnerHTML={{ __html: message }} />
        <div className="confirmation-actions">
          <Button text={confirmText} color="blue" disabled={loading} loader={loading} onClick={onConfirm} />
          <Button text={cancelText} color="gray" onClick={onCancel} />
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
